export default "__VITE_ASSET__BzRJ8IP8__"